/* eslint-disable react/prop-types */
// Power.jsx
import React from 'react'
import styles from '../../../../css/compacts.module.css'

const PowerDefault = ({ style }) => <Power style={style} />

export default PowerDefault

const Power = ({ style }) => <span className={`fa fa-power-off ${styles.text}`} style={style} />
